const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBplogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 401.1 127.6",
    style: {
      enableBackground: "new 0 0 401.1 127.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE66",
      stroke: "#242B40",
      strokeMiterlimit: 10
    },
    d: "M42.6,72.6c-1.4,0.8-3,1.3-4.8,1.3c-2.5,0-4.7-1-6.4-2.5 c-1.8-1.7-2.9-4.1-2.9-6.8V63c0-5.1,4.2-9.3,9.3-9.3c2,0,3.9,0.7,5.5,1.8c0.1-0.6,0.3-1.3,0.5-1.9c1.6-5.1,4.7-9.5,8.7-12.8 c-4.2-2.8-9.2-4.4-14.7-4.4c-3.3,0-6.4,0.6-9.3,1.7v0.1c0-2.5-0.3-4.8-1-7.1c-2.3-8.2-8.4-14.9-16.4-17.8l0,49.7c0,0,0,0,0,0 c0,0,0,0,0,0v1.6c0,2.7,0.4,5.4,1.2,7.9c3.4,10.8,13.5,18.7,25.4,18.7c1.6,0,3.2-0.2,4.8-0.4V72.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#242B40",
      strokeMiterlimit: 10
    },
    d: "M100.3,63.5c0-14.7-11.9-26.6-26.6-26.6 c-11.9,0-22.1,7.9-25.4,18.7c-0.8,2.5-1.2,5.1-1.2,7.9v0.1c0,0,0,0,0,0c0,0,0,0,0,0v49.9c7.9-3,14.1-9.6,16.4-17.8 c0.6-2.3,1-7.1,1-7.1v0c2.9,1.1,6,1.7,9.3,1.7c11.9,0,22.1-7.9,25.4-18.7c0.8-2.5,1.2-5.1,1.2-7.9h0 C100.3,63.6,100.3,63.6,100.3,63.5z M80,70.4c-1.7,1.6-3.9,2.5-6.4,2.5c-5.1,0-9.3-4.2-9.3-9.3v-0.1c0-2.7,1.1-5.1,2.9-6.8 c1.7-1.6,3.9-2.5,6.4-2.5c5.1,0,9.3,4.2,9.3,9.3c0,0,0,0.1,0,0.1h0C82.9,66.3,81.8,68.7,80,70.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#242B40",
      strokeMiterlimit: 10
    },
    d: "M64.3,63.5c0,0.3,0,0.6,0,0.9L64.3,63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#242B40",
      strokeMiterlimit: 10
    },
    d: "M82.9,63.6c0-0.3,0-0.6,0-0.9L82.9,63.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE66",
      stroke: "#FFCE66",
      strokeMiterlimit: 10
    },
    d: "M157.8,58.9c2.4,0,4.7,0.4,6.8,1.3c2.1,0.8,4,2,5.6,3.5 c1.6,1.5,2.8,3.2,3.8,5.2s1.4,4.1,1.4,6.4c0,2.3-0.5,4.4-1.4,6.4s-2.2,3.7-3.8,5.2c-1.6,1.5-3.5,2.6-5.6,3.5 c-2.1,0.8-4.4,1.3-6.8,1.3c-2.4,0-4.7-0.4-6.8-1.3c-2.1-0.8-4-2-5.6-3.5c-1.6-1.5-2.8-3.2-3.8-5.2c-0.9-2-1.4-4.1-1.4-6.4v-0.1v-38 h6.8L147,62.3c1.5-1.1,3.2-1.9,5-2.5C153.8,59.2,155.8,58.9,157.8,58.9z M157.8,85.1c1.5,0,2.8-0.3,4.1-0.8 c1.3-0.5,2.4-1.2,3.4-2.1c1-0.9,1.7-2,2.3-3.2c0.6-1.2,0.8-2.5,0.8-3.9c0-1.4-0.3-2.6-0.8-3.9c-0.6-1.2-1.3-2.3-2.3-3.2 c-1-0.9-2.1-1.6-3.4-2.1c-1.3-0.5-2.7-0.8-4.1-0.8c-1.5,0-2.8,0.3-4.1,0.8c-1.3,0.5-2.4,1.2-3.4,2.1c-1,0.9-1.7,2-2.3,3.1 c-0.6,1.2-0.9,2.5-0.9,3.8v0.1c0,1.4,0.3,2.6,0.9,3.9c0.6,1.2,1.3,2.3,2.3,3.2c1,0.9,2.1,1.6,3.4,2.1 C155,84.9,156.4,85.1,157.8,85.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE66",
      stroke: "#FFCE66",
      strokeMiterlimit: 10
    },
    d: "M206.2,77.3h-13.3c0.3,1.1,0.7,2.2,1.4,3.1 c0.6,1,1.4,1.8,2.4,2.5c0.9,0.7,2,1.2,3.1,1.6c1.2,0.4,2.4,0.6,3.7,0.6c1.5,0,3-0.3,4.3-0.9c1.4-0.6,2.5-1.4,3.6-2.4h1.3h6.8 c-0.3,0.6-0.6,1.2-1,1.8c-0.4,0.6-0.8,1.1-1.2,1.6c-1.6,1.9-3.6,3.4-6,4.5c-2.4,1.1-5,1.7-7.8,1.7c-2.4,0-4.7-0.4-6.8-1.3 c-2.1-0.8-4-2-5.6-3.5c-1.6-1.5-2.8-3.2-3.8-5.2c-0.9-2-1.4-4.1-1.4-6.4c0-2.3,0.5-4.4,1.4-6.4c0.9-2,2.2-3.7,3.8-5.2 c1.6-1.5,3.5-2.6,5.6-3.5c2.1-0.8,4.4-1.3,6.8-1.3c2.8,0,5.4,0.6,7.8,1.7c2.4,1.1,4.4,2.7,6,4.6c1.5,1.6,2.5,3.6,3.2,5.8 c0.4,1.3,0.6,2.7,0.6,4.2c0,0.7-0.1,1.4-0.2,2.1h-6.9H206.2z M203.4,65.3c-2.2,0-4.1,0.5-5.8,1.6c-1.7,1-3,2.4-3.9,4.1h15.5h3.9 c-0.2-0.3-0.4-0.7-0.6-1c-0.2-0.3-0.4-0.6-0.6-0.9c-1-1.2-2.3-2.1-3.7-2.8C206.6,65.6,205,65.3,203.4,65.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE66",
      stroke: "#FFCE66",
      strokeMiterlimit: 10
    },
    d: "M255,61.3c1.5,0.9,2.8,2.1,3.9,3.4l-3.9,2.8l-1.5,1.1 c-0.8-1-1.7-1.9-3-2.5c-1.2-0.6-2.5-0.9-4-0.9c-1.2,0-2.2,0.2-3.3,0.6c-1,0.4-1.9,1-2.7,1.7c-0.8,0.7-1.4,1.5-1.8,2.5 c-0.4,0.9-0.7,2-0.7,3v11.7v6.6h-6.8V73V58.9h6.8v2.4c1.2-0.7,2.5-1.3,3.9-1.7c1.4-0.4,2.9-0.6,4.5-0.6c1.5,0,3,0.2,4.4,0.6 C252.5,59.9,253.8,60.5,255,61.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10
    },
    d: "M283.1,58.8c2.4,0,4.7,0.4,6.8,1.3c2.1,0.9,4,2,5.6,3.5 c1.6,1.5,2.9,3.2,3.8,5.2c0.9,2,1.4,4.1,1.4,6.4c0,2.3-0.5,4.4-1.4,6.4s-2.2,3.7-3.8,5.2c-1.6,1.5-3.5,2.7-5.6,3.5 c-2.1,0.9-4.4,1.3-6.8,1.3c-2,0-4-0.3-5.8-0.9c-1.8-0.6-3.5-1.5-5-2.5v25.3h-6.8V75.2v-0.1c0-2.3,0.5-4.4,1.4-6.4 c0.9-2,2.2-3.7,3.8-5.2c1.6-1.5,3.5-2.7,5.6-3.5C278.4,59.2,280.7,58.8,283.1,58.8z M283.1,85.1c1.5,0,2.8-0.3,4.2-0.8 c1.3-0.5,2.4-1.3,3.4-2.2c1-0.9,1.7-2,2.3-3.2c0.6-1.2,0.9-2.5,0.9-3.9s-0.3-2.6-0.9-3.9c-0.6-1.2-1.4-2.3-2.3-3.2 c-1-0.9-2.1-1.6-3.4-2.2c-1.3-0.5-2.7-0.8-4.2-0.8c-1.5,0-2.9,0.3-4.2,0.8c-1.3,0.5-2.4,1.3-3.4,2.2c-1,0.9-1.7,2-2.3,3.2 c-0.6,1.2-0.8,2.5-0.8,3.9v0.1c0,1.4,0.3,2.6,0.9,3.9c0.6,1.2,1.3,2.3,2.3,3.2c1,0.9,2.1,1.6,3.4,2.1 C280.3,84.9,281.7,85.1,283.1,85.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10
    },
    d: "M327.9,58.9c2.4,0,4.7,0.4,6.9,1.3c2.1,0.9,4,2,5.6,3.5 c1.6,1.5,2.9,3.2,3.8,5.2c0.9,2,1.4,4.2,1.4,6.4v16h-6.8v-3c-1.5,1.1-3.2,1.9-5,2.5c-1.8,0.6-3.8,0.9-5.8,0.9 c-2.4,0-4.7-0.4-6.9-1.3c-2.1-0.9-4-2-5.6-3.5s-2.9-3.2-3.8-5.2c-0.9-2-1.4-4.1-1.4-6.4c0-2.3,0.5-4.4,1.4-6.4 c0.9-2,2.2-3.8,3.8-5.2c1.6-1.5,3.5-2.7,5.6-3.5C323.2,59.3,325.5,58.9,327.9,58.9z M328,85.4c1.5,0,2.9-0.3,4.2-0.8 c1.3-0.5,2.4-1.3,3.4-2.2c1-0.9,1.7-2,2.3-3.2c0.6-1.2,0.9-2.5,0.9-3.9c0-1.4-0.3-2.7-0.9-3.9c-0.6-1.2-1.4-2.3-2.3-3.2 c-1-0.9-2.1-1.6-3.4-2.2c-1.3-0.5-2.7-0.8-4.2-0.8c-1.5,0-2.9,0.3-4.2,0.8c-1.3,0.5-2.4,1.3-3.4,2.2c-1,0.9-1.8,2-2.3,3.2 c-0.6,1.2-0.9,2.5-0.9,3.9c0,1.4,0.3,2.7,0.9,3.9c0.6,1.2,1.3,2.3,2.3,3.2c1,0.9,2.1,1.6,3.4,2.2C325,85.2,326.4,85.4,328,85.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10
    },
    d: "M393.3,59l-15.4,29.7l-4.1,7.8l-8.2,15.9h-7.9l12.4-24 L356.2,59h7.8l10.2,21.7L385.4,59H393.3z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 118.7,
    y: 36.9,
    style: {
      fill: "#FFFFFF"
    },
    width: 0.6,
    height: 54.5
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBplogo);
export default __webpack_public_path__ + "static/media/bplogo.ce9dff785ab2099a5cceb345cdfbf684.svg";
export { ForwardRef as ReactComponent };